import React from "react";
import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";
import { oc } from "ts-optchain";
import { AnnouncementModalQuery as AnnouncementModalQueryType } from "./__generated__/AnnouncementModalQuery";
import AnnouncementModal from "./AnnouncementModal";

// == Types ================================================================

// == Constants ============================================================

const ANNOUNCEMENT_MODAL_QUERY = gql`
  query AnnouncementModalQuery {
    Viewer {
      id
      announcements(first: 1) {
        edges {
          cursor
          node {
            id
            ...AnnouncementModalFragment
          }
        }
        # pageInfo
      }
    }
  }
  ${AnnouncementModal.fragments}
`;

// == Component ============================================================

export default function AnnouncementModalQuery() {
  const { loading, data, error } = useQuery<AnnouncementModalQueryType>(ANNOUNCEMENT_MODAL_QUERY);

  if (loading || error) return null;
  const announcement = oc(data).Viewer.announcements.edges[0].node();
  if (!announcement) return null;
  return <AnnouncementModal announcement={announcement} />;
}

// == Styles ===============================================================
